import Vue from 'vue'
import Toast, { POSITION, TYPE } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

Vue.use(Toast, {
  position: POSITION.TOP_CENTER,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
  maxToasts: 5,
})

Vue.$toastDefaults = {
  success: {
    type: TYPE.SUCCESS,
    timeout: 3000,
  },
  error: {
    type: TYPE.ERROR,
    timeout: 3000,
  },
}
